var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.maxLength')
    }
  }, [_c('el-input', {
    staticClass: "hide-spin-button",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "min": "1"
    },
    nativeOn: {
      "input": function($event) {
        return _vm.inputNumberHandler.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.maxLength),
      callback: function($$v) {
        _vm.maxLength = $$v
      },
      expression: "maxLength"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1877ca","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/maxLength-editor.vue
// module id = null
// module chunks = 